// extracted by mini-css-extract-plugin
export default {"root":"IconCategoryTest_root__-Ra5f"};